import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createTimeTrackingActivityCompilationEntityInfo } from 'record-it-time-common/entity/entities/TimeTrackingActivityCompilation/createTimeTrackingActivityCompilationEntityInfo';
import { TimeTrackingActivityCompilation } from './timeTrackingActivityCompilationTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const timeTrackingActivityCompilationEntityInfo =
  createTimeTrackingActivityCompilationEntityInfo<TimeTrackingActivityCompilation>(
    {
      additionalFieldInfos:
        EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
    }
  );
